document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".add-to-wishlist");

  buttons.forEach((button) => {
    button.addEventListener("click", function(e) {
      e.preventDefault();

      // Récupérer les données à envoyer au serveur
      let thisID = this.dataset.id;

      // Envoyer la requête avec Fetch API
      fetch(my_ajax_object.ajax_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: new URLSearchParams({
          action: "wishlist_action",
          thisID: thisID,
        }),
      })
        .then((response) => response.text())
        .then((data) => {
          data = data.trim(); // Supprime les espaces invisibles
          if (data) {
            this.classList.add("active");
          } else {
            this.classList.remove("active");
          }
        })
        .catch((error) => console.error("Erreur:", error));
    });
  });
});
